import client from './client';
// 如果你有定义类型，可以取消注释下面这行，否则用 any
// import type { StorageProject, StorageStatistics } from '../types';

// 定义 storageApi 对象并导出
export const storageApi = {
  // 获取储能项目列表
  getStorageProjects: (params?: any) => {
    return client.get('/storage/projects', { params });
  },

  // 获取储能统计数据
  getStorageStatistics: (params?: any) => {
    return client.get('/storage/statistics', { params });
  },

  // 获取单个项目详情 (可选，根据需要补充)
  getStorageProject: (id: string | number) => {
    return client.get(`/storage/projects/${id}`);
  }
};